<template>
  <van-popup v-model="show" position="right" :style="{ width: '100%', height: '100%' }" zIndex="9" :lock-scroll="false">
    <div class="hs-nation-picker" @click.stop>
      <c-header
          class="c-header-new"
          :title="type === 'mobileCountryCode' ? $t('MobileCode') : $t('Nation')"
          leftIcon1="icons_24pt_back.png"
          :leftFn1="close"
      />

      <!-- 搜索框 -->
      <hs-search-bar-new
          className="style2"
          v-model="searchTxt"
          :placeholder="$t('Search_1')"
          :hasClear="!!searchTxt"
          @clear="searchTxt = ''"
      />

      <div class="hs-index-bar" v-if="indexList && !searchTxt">
        <div class="index" v-for="(item, index) in indexList" :key="index" @click="selectIndexList(item)">{{item}}</div>
      </div>

      <hs-scroll ref="tableView" :data="[details]" class="tableView">
        <ul>
          <template v-if="searchTxt">
            <hs-null
                v-if="noValue(JSON.stringify(vaguelist))"
                style="padding-top: calc(38dvh - 88px)"
                styleType="empty"
                :title="$t('NoDataContent')"
            />
            <hs-nation-item
                :details="{NationList: vaguelist}"
                :key="`search`"
                @select="_select"
                :NationCode="NationCode"
                :type="type"
            />
            <hs-all-load-text v-if="vaguelist.length" />
          </template>
          <template v-else>
            <hs-nation-item :details="details.hot" key="hot" @select="_select" :NationCode="NationCode" :type="type" />
            <template v-if="details.list">
              <hs-nation-item
                  v-for="(item, index) in details.list"
                  :details="item"
                  :key="`city${index}`"
                  @select="_select"
                  :NationCode="NationCode"
                  :type="type"
              />
            </template>
          </template>
          <div style="height: 50px"></div>
        </ul>
      </hs-scroll>
    </div>
  </van-popup>
</template>

<script type='text/ecmascript-6'>
import HsScroll from 'base/hs-scroll/hs-scroll'
import {
  kpiIntlflightGetNationList,
  kpiSystemInfoGetMobileCountryCodes,
  kpiSystemInfoGetMobileCountryCodesByKeyword
} from 'api'
import {mapGetters} from 'vuex';
import HsNull from "@/base/hs-null/hs-null.vue";
import HsSearchBarNew from "@/base/hs-search-bar/hs-search-bar-new.vue";
import HsNationItem from "@/base/hs-nation/hs-nation-item.vue";
import HsAllLoadText from "@/base/hs-null/hs-all-load-text.vue";
export default {
  props: {
    NationCode: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showSearchDetails: false,
      show: false,
      details: {},
      searchTxt: '',
      vaguelist: [],
      indexList: [],
    };
  },
  computed: {
    ...mapGetters([
      'isEMobile7Browser'
    ])
  },
  watch: {
    show(val) {
      if (val) {
        this.searchTxt = ''
        this._getDetails()
      }
    },
    searchTxt(val) {
      this.timer && clearTimeout(this.timer); // eslint-disable-line
      this.timer = setTimeout(() => {
        this._vague(val)
      }, 100)
    }
  },
  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
    },

    _getDetails() {
      if (this.type === 'mobileCountryCode') {
        this._getMobileCountryCode()
      } else {
        this._getNationList()
      }
    },

    _getNationList() {
      kpiIntlflightGetNationList({
        LanguageType: (this.language === 'CN' || this.language === 'TC') ? 0 : 1
      }).then((res) => {
        console.log('更新国籍JSON: ', res)
        let original = JSON.parse(JSON.stringify(res.ResultData))
        // 挑选出热门
        let hot = JSON.parse(JSON.stringify(original))[0]
        let list = JSON.parse(JSON.stringify(original)).slice(1)
        // 重新组合
        this.details = {hot: hot, list: list}
        this.indexList = [
          hot.Label, ...list.map(v => v.Label)
        ]

        let NationList = hot.NationList || []
        let china = NationList.filter(v => v.NationName_CN === '中国')[0]
        if (china) {
          this.$emit('setDefaultNation', china)
        }
      })
    },

    /** 获取手机国家代码 */
    _getMobileCountryCode() {
      kpiSystemInfoGetMobileCountryCodes({
        LanguageType: (this.language === 'CN' || this.language === 'TC') ? 0 : 1
      }).then((res) => {
        console.log('更新国籍JSON: ', res)
        let original = JSON.parse(JSON.stringify(res.ResultData))
        original = original.map(v => {
          return {
            Label: v.Label,
            NationList: v.MobileCountryCodeList,
          }
        })
        // 挑选出热门
        let hot = JSON.parse(JSON.stringify(original))[0]
        let list = JSON.parse(JSON.stringify(original)).slice(1)
        this.details = {hot: hot, list: list}
        this.indexList = [
          hot.Label, ...list.map(v => v.Label)
        ]
      })
    },

    /** 索引栏选中 滚动 */
    selectIndexList(index) {
      console.log(index)
      this.$refs.tableView && this.$refs.tableView.scrollToElement(`#letter${index}`, 300)
    },

    /** 模糊搜索 */
    _vague(val) {
      let res = []
      if (this.type === 'mobileCountryCode') {
        this._getMobileCountryCodesByKeyword(val)
      } else {
        let valToUpperCase = val.toUpperCase() // 转大写
        this.details.list.forEach(element => {
          element.NationList.forEach(elementChild => {
            if (
                elementChild.NationName_CN.includes(valToUpperCase) ||
                elementChild.NationName_EN.includes(valToUpperCase) ||
                elementChild.NationDistCode.includes(valToUpperCase) ||
                elementChild.NationSpell.includes(valToUpperCase)) {
              res.push(elementChild)
            }
          })
        })
        this.vaguelist = res
      }
    },


    _getMobileCountryCodesByKeyword(val) {
      kpiSystemInfoGetMobileCountryCodesByKeyword({
        Keyword: val
      }).then(res => {
        console.log(res)
        this.vaguelist = res.ResultData || []
      })
    },

    /** 选择 */
    _select(item) {
      this.$emit('select', item)
      this.close()
    }
  },
  components: {
    HsAllLoadText,
    HsNationItem,
    HsSearchBarNew,
    HsNull,
    CHeader: () => import('components/c-header/c-header'),
    HsClose: () => import('base/hs-close/hs-close'),
    HsScroll,
  }
};
</script>

<style lang='stylus' scoped='' rel='stylesheet/stylus'>
@import '~common/stylus/variable'
@import '~common/stylus/base'
@import '~common/stylus/popup-mask.styl'
.hs-nation-picker
  width 100%
  height 100%
  position absolute
  top 0
  left 0
  background-color $color_white
  border-top-left-radius 10px
  border-top-right-radius 10px
  z-index 10
  overflow hidden
  .hs-index-bar{
    position: fixed;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    color: $color_theme_300;
    z-index: 1;
    >.index{
      @extend .flex-center;
      @extend .hs-font-overline-3;
      padding: 1px;
      min-width: 20px;
    }
  }
  >.tableView
    width 100%
    height calc(100% - 56px - 48px)
    overflow: hidden;
    .hs-index-bar{
      width: 100%;
      :deep(.van-index-bar__index){
        color: transparent;
      }
    }
</style>
